<template>
    <div class="content">
        <h1>CURRICULUM VITAE</h1>
        <h2>Berufspraxis</h2>
        <p class="p-item">
            seit 06.2016<br>
            <b>Peakwork AG Düsseldorf</b><br>
            Senior Frontend Software Developer
        </p>
        <p class="p-item">
            07.2011 - 05.2016<br>
            <b>Cologne Systems Köln</b><br>
            Head of UI Development
        </p>
        <p class="p-item">
            04.2005 - 06.2011<br>
            <b>TravelTainment AG Aachen</b><br>
            Web-Entwickler und Azubi-Pate
        </p>
        <p class="p-item">
            10.2003 - 04.2004<br>
            <b>Forschungszentrum Jülich - Zentralinstitut für Elektronik</b><br>
            Berufspraktikum | Softwareentwicklung im Bereich Hirnzellenstimulation für Parkinsonerkrankte
        </p>
        <p class="p-item">
            02.1999 - 07.2002<br>
            <b>Mineralienfachhandel Eckel & Weißenfeld Aachen</b><br>
            Einkauf, Verkauf, PC-Administration
        </p>
        <h2>Ausbildung</h2>
        <p class="p-item">
            08.2002 - 07.2004<br>
            <b>Microrep GmbH Aachen</b><br>
            Ausbildung zum Fachinformatiker Anwendungsentwicklung mit erfolgreichem IHK-Abschluss
        </p>
        <h2>Studium</h2>
        <p class="p-item">
            10.1990 - 09.1999<br>
            <b>Rheinisch Westfälisch Technische Hochschule Aachen</b><br>
            Studium Philosophie - Psychologie - Theologie<br>
            Studium Bauingenieurwesen
        </p>
        <h2>Zivildienst</h2>
        <p class="p-item">
            02.1989 - 10.1990<br>
            <b>Deutsches Rotes Kreuz Aachen</b><br>
            Abteilung Krankentransport, Rettungshelfer und Fahrer
        </p>
        <h2>Schule</h2>
        <p class="p-item">
            08.06.1988<br>
            <b>Kaiser-Karls-Gymnasium Aachen</b><br>
            Abitur
        </p>
    </div>
</template>

<script>
export default {
    name: 'curriculum',
    methods: {
        emitLogData(page, action) {
            this.$emit(
                'log-it',
                '{"page": "' + page + '", "action": "' + action + '"}'
            );
        }
    },
    mounted() {
        this.emitLogData('confirmation', 'visit');
    },
    beforeDestroy() {
        this.emitLogData('confirmation', 'leave');
    }
};
</script>

<style lang="scss" scoped>
    .p-item {
        margin: 20px 0!important;
    }
</style>
